import _ from 'lodash';
import Immutable from 'seamless-immutable';
import { assetRefService } from '../../common/Services';
import { prepCategoryLabel } from '../../common/Utils.js';

/**
 * App card is used in the app store and the app create project.
 * @typedef {Object} AppCard
 * @property {string} appId - the app id is a definition of the app itself used to navigate to the appId home page (for example giveway, print-coupon, etc)
 * @property {string} actionRef - a string nav ref used to navigate to the apps landing page when selecting the card, generally in the form of: route:app/<category apps id>
 * @property {string} assetRef - a simple ref that hosts the apps background image for the card
 * @property {string} image - an image string ref in the shape sysui:image:450x253:/store/<category name>/thumbnail.jpg used to generated the exact background image for the card
 * @property {array} keyCategories - an array of category strings, these are designed to showcase a quick brief of the experiences features and are displayed via color lozenge in SkillCategoryLozenge.jsx
 * @property {array} keyCategoryLabels - a human readable set of labels to be used displayed in the lozenge on category card hover
 * @property {string} name - the header title copy text
 * @property {string} summary - a short description for the experience template
 * @property {string} typeRef - a simple string generally used to generate a CK icon to represent the card
 * @property {number} id - the database reference for the experience template, mostly use in the wizards to fetch the full template data
 */

/**
 * Transform a BE instance of an into a FE app card model
 * @return {Object}  AppCard
 */
function deserialize(appDetails) {
  const result = _.pick(appDetails, _keys);

  result.image = assetRefService.pathFromAssetRef(result.assetRef);
  result.actionRef = `route:app/${result.appId}`;
  result.icon = appDetails.typeRef === 'default' ? 'app' : appDetails.typeRef;

  //turns all technical keyCategories into human readable category text (replacing - and & with spaces or renaming micro experiences to nextgen)
  //WARNING! this is not supported on all app cards
  if (result.keyCategories)
    result.keyCategoryLabels = result.keyCategories.map((keyCategory) => prepCategoryLabel(keyCategory));

  return Immutable(result);
}

const _keys = ['relatedExperiences', 'appId', 'assetRef', 'keyCategories', 'name', 'summary', 'typeRef', 'id'];

export default {
  deserialize,
};
